import styled from "@emotion/styled";
import theme from "@theme";
import { css, Global } from "@emotion/react";

const globalStyles = css`
  .MuiList-root {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    min-width: 140px !important;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
